module.exports = __webpack_public_path__ + "static/media/fpro.c544ab5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assign-prescriptions/images/fpro.png
// module id = 12877
// module chunks = 0